import React from 'react'
import Svg, { G, Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconCameraSwitch = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconCameraSwitch.dimensions.width} ${IconCameraSwitch.dimensions.height}`}
      {...otherProps}
    >
      <G fillRule="nonzero" fill="none">
        <Path
          stroke={color || Color.premiumBlack}
          strokeWidth={1.091}
          d="m8.095 1.702-.731.698c-.405.39-.944.609-1.506.61H3.273A2.062 2.062 0 0 0 1.09 4.92v11.498a2.062 2.062 0 0 0 2.182 1.92h17.454a2.062 2.062 0 0 0 2.182-1.92V4.92A2.062 2.062 0 0 0 20.727 3h-2.585a2.182 2.182 0 0 1-1.506-.61l-.73-.7a2.182 2.182 0 0 0-1.506-.6H9.6a2.182 2.182 0 0 0-1.505.612Z"
        />
        <Path
          fill={color || Color.premiumBlack}
          fillRule="evenodd"
          d="M7.262 12.511c.243.15.567.085.725-.146l.313-.46c.586 1.559 2.15 2.655 3.989 2.635 1.528-.017 2.849-.8 3.566-1.968a.488.488 0 0 0-.187-.684.537.537 0 0 0-.716.178c-.537.874-1.525 1.461-2.675 1.474-1.355.015-2.507-.773-2.965-1.906l.561.349c.243.15.567.084.725-.147a.487.487 0 0 0-.154-.692l-1.582-.982a.538.538 0 0 0-.724.146l-1.03 1.512a.487.487 0 0 0 .154.691ZM16.738 8.086a.539.539 0 0 0-.725.147l-.313.46c-.586-1.559-2.15-2.656-3.989-2.635-1.528.017-2.849.8-3.566 1.968a.488.488 0 0 0 .187.684c.25.14.57.06.716-.178.537-.874 1.525-1.462 2.675-1.474 1.355-.015 2.507.773 2.965 1.906l-.562-.349a.539.539 0 0 0-.724.147.487.487 0 0 0 .154.692l1.582.982c.243.15.567.085.724-.146l1.03-1.512a.487.487 0 0 0-.154-.692Z"
          clipRule="evenodd"
        />
      </G>
    </Svg>
  )
}

IconCameraSwitch.dimensions = {
  width: 24,
  height: 20,
}

export default IconCameraSwitch
